module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/apple-store-dda92abdae923996c0ce9fd6b1614ce0.png";